import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Drawer,
  Space,
  Card,
  Empty,
  Tooltip,
  Badge,
  FloatButton,
  List,
  Modal,
} from "antd";
import { BellOutlined, DoubleRightOutlined } from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import { debounce } from "lodash";
import axios from "axios";
import "../../styles/NotificationNavBarLayout.css";

const text = <span>Show More</span>;

const NoticeNavbarLayout = () => {
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState("right");
  const [arrow, setArrow] = useState("Show");
  const [topNoticeList, setTopNoticeList] = useState([]);
  const [topList, setTopList] = useState([]);
  const [clickedNotices, setClickedNotices] = useState([]);
  const [loadingLocalStorage, setLoadingLocalStorage] = useState(true);
  const [filteredNotices, setFilteredNotices] = useState([]);
  const [notices, setNotices] = useState([]);
  const [badgeCount, setBadgeCount] = useState(0);
  const base_url = process.env.REACT_APP_BASE_URL;


  const [modalVisible, setModalVisible] = useState(false);
  const [selectedNotice, setSelectedNotice] = useState(null);

  // useEffect(() => {
  //   const storedNotices = JSON.parse(localStorage.getItem('topNoticeList')) || [];
  //   setTopNoticeList(storedNotices);
  // }, []);

  // // Save topNoticeList to local storage whenever it changes
  // useEffect(() => {
  //   localStorage.setItem('topNoticeList', JSON.stringify(topNoticeList));
  // }, [topNoticeList]);


  const fetchData = async () => {
    try {
      const accessToken = sessionStorage.getItem("accessToken");
      const user_id = sessionStorage.getItem("userData");

      const response = await axios.get(
        `${base_url}/api/v1/client/notice/list`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      const { code, data, total_notices } = response.data;

      if (code === 200) {
        const updatedList = data.map((notice) => ({
          ...notice,
          readed: notice.readed || false,
        }));

        const unreadNoticesCount = updatedList.filter((notice) => !notice.readed).length;

        setTopNoticeList(updatedList);
        setNotices(updatedList);
        setBadgeCount(unreadNoticesCount);
      }
      // setTopList(topNoticeList);
      //setClickedNotices(storedClickedNotices);
    } catch (error) {
    } finally {
      setLoadingLocalStorage(false); // Set loading state to false
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const showDetailsModal = (notice) => {
    setSelectedNotice(notice);
    setModalVisible(true);
  };

  const closeDetailsModal = () => {
    setModalVisible(false);
  };

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const handleNoticeClick = async (notice) => {
    try {
      //fetchData();
      if (notice.readed) {
        // If the notice is already marked as read, don't make the API call
        return;
      }
      const accessToken = sessionStorage.getItem("accessToken");
      const response = await axios.put(
        `${base_url}/api/v1/client/notice/read/${notice.notice_id}`,
        {},
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      if (response.data.success) {
        const updatedList = topNoticeList.map((item) =>
          item.notice_id === notice.notice_id ? { ...item, readed: true } : item
        );
        setTopNoticeList(updatedList);
        setNotices(updatedList);
      }
    } catch (error) {
      // Handle the error appropriately (e.g., show an error message)
    }
  };

  

  return (
    <>
      <Space>
        <Button
          onClick={showDrawer}
          style={{ border: "none", background: "none" }}
        >
          <Badge count={badgeCount > 0 ? badgeCount : 0} overflowCount={99}>
            <BellOutlined style={{ color: "white", fontSize: "24px" }} />
          </Badge>
        </Button>
      </Space>

      <Drawer
        title={
          <div
            style={{
              color: "white",
              textAlign: "center",
              fontWeight: "lighter",
            }}
          >
            Notifications
          </div>
        }
        placement={placement}
        width={450}
        onClose={onClose}
        headerStyle={{ background: "rgb(0, 176, 240)", color: "red" }}
        open={open}
        bodyStyle={{
          padding: "0px"
        }}
      >
        {topNoticeList.length === 0 ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_DEFAULT}
            description={<p style={{ color: "#ababab" }}>No New Messages!</p>}
          />
        ) : (
          <List
            dataSource={notices}
            renderItem={(notice) => (
                <>
              <div
                key={notice.notice_id}
                type="inner"
                // onClick={async () => {
                //   const success = await handleNoticeClick(notice);
                //   if (success) {
                //     showDetailsModal(notice);
                //   }
                // }}
                onClick={() => handleNoticeClick(notice) && showDetailsModal(notice)}
                //disabled={notice.disabled} // Set the 'disabled' property for the notice card
                style={{
                  cursor: notice.readed ? "allowed" : "pointer",
                  color: notice.readed ? "gray" : "black",
                  fontSize: "20px",
                  fontWeight: notice.readed ? "400" : "bold",
                  padding: "8px 12px"
                }}
              >
                <span>{notice.notice_title}</span>
              </div>
                  <div style={{fontSize: "11px", color: "#555555", padding: "0px 12px 3px"}}>{notice.time}</div>
              <div style={{background: "lightgray", width: "100%", height: "1px"}}/>
                </>
            )}
          />
        )}
        <NavLink to="/notification-list">
          <Tooltip placement="left" title={text} arrow={mergedArrow}>
            <FloatButton
              badge={{
                count: 0,
              }}
              icon={<DoubleRightOutlined />}
            />
          </Tooltip>
        </NavLink>
      </Drawer>
      <Modal
        open={modalVisible}
        onCancel={closeDetailsModal}
        footer={null}
        centered
      >
        {selectedNotice && (
        <div>
          <div>
            <div
              style={{
                textAlign: "left",
                fontSize: "32px",
                fontWeight: "normal",
                marginBottom: "10px",
                color: "#00B0F0",
              }}
            >
              {selectedNotice.notice_title}
              <hr style={{ borderTop: "2px solid black" }} />
            </div>
            {/* <div style={{ textAlign: "center", fontSize: "25px" }}>
              Notice Details
            </div> */}
          </div>
          {/* <div style={{ marginBottom: "10px" }}> */}
            <div className="notice-content">
            {selectedNotice.notice_content}
            </div>
          {/* </div> */}
          <div style={{ textAlign: "right"}}>{selectedNotice.time}</div>
        </div>
        )}
      </Modal>
    </>
  );
};

export default NoticeNavbarLayout;



